import { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import FeedbackDialog from './FeedbackDialog';

/**
 * Floating bottom-right feedback button. Always visible while the user is in
 * the app. Clicking opens the dialog which captures session state + screenshot.
 */
export default function FeedbackButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        title="Send feedback"
        className="fixed bottom-4 right-4 z-40 flex items-center gap-2 px-3 py-2 rounded-full bg-primary-600 hover:bg-primary-700 text-white shadow-lg text-sm font-medium transition-colors"
      >
        <MessageSquare size={16} />
        Feedback
      </button>

      {open && <FeedbackDialog onClose={() => setOpen(false)} />}
    </>
  );
}
